export const contentTableConfig = {
  title: '电话资源列表',
  propList: [
    {
      prop: 'sourceChannel',
      label: '渠道来源',
      minWidth: '120'
    },
    {
      prop: 'vestDeptName',
      label: '归属组别',
      minWidth: '120'
    },
    {
      prop: 'customPhone',
      label: '客户手机号',
      minWidth: '120'
    },
    {
      prop: 'createTime',
      label: '入库时间',
      minWidth: '120'
    },
    {
      prop: 'enterDbCount',
      label: '入库次数',
      minWidth: '120'
    },
    {
      prop: 'status',
      label: '状态',
      minWidth: '120'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/phoneResource/dataImport'
}
